var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSquareDown = function SvgIconArrowSquareDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.48 16.628q.125-.07.227-.17l3.179-3.179a1 1 0 0 0-1.415-1.414L13 13.336V8.25a1 1 0 1 0-2 0v5.085l-1.47-1.47a1 1 0 1 0-1.415 1.414l3.161 3.161c.183.191.44.31.724.31M12.48 16.628a1 1 0 0 1-.48.122"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 19.5c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75h-15A1.75 1.75 0 0 0 2.75 4.5zm2-.25V4.75h14.5v14.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArrowSquareDown;